<template>
  <div class="notes-history">
    <slot name="title" />

    <div v-if="isLoading" class="notes-history__empty">
      <span>Carregando…</span>
    </div>

    <div v-else-if="!appointmentNotes.length" class="notes-history__empty">
      <span>Nenhuma nota anterior</span>
    </div>

    <ul v-else class="notes-history__list">
      <li
        v-for="note in appointmentNotes"
        :key="note.id"
        class="notes-history__item"
      >
        <div class="notes-history__item-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              d="M14 2v6h6M12 11v4M10 13h4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <span class="notes-history__item-date">
          {{ formatDate(note.created_at) }}
        </span>
        <button class="notes-history__item-btn" @click="showModal(note.id)">
          Ver
        </button>
      </li>
    </ul>

    <b-modal
      :title="appointmentNoteDate ? formatDate(appointmentNoteDate) : ''"
      id="notes-modal"
      ref="notes-modal"
      size="lg"
      hide-footer
      modal-class="dark-modal dark-modal--light"
    >
      <div class="notes-history__modal-body" v-html="appointmentNote" />
    </b-modal>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import { pt as locale } from "date-fns/locale";
export default {
  name: "AppointmentNotesHistory",
  components: {},
  props: {
    appointmentId: {
      type: String,
      default: ""
    },
    patientId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: false,
      appointmentNotes: [],
      appointmentNote: "",
      appointmentNoteDate: ""
    };
  },
  mounted() {
    if (this.patientId || this.appointmentId) this.fetchAppointmentNotes();
  },
  methods: {
    fetchAppointmentNotes() {
      this.isLoading = true;
      const action = this.patientId
        ? "appointments/fetchAppointmentNotesByPatient"
        : "appointments/fetchAppointmentNotes";
      const param = this.patientId || this.appointmentId;
      this.$store
        .dispatch(action, param)
        .then(response => {
          this.appointmentNotes = response.data;
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
    },
    showModal(noteId) {
      const note = this.appointmentNotes.find(n => n.id === noteId);
      this.appointmentNote = note.description;
      this.appointmentNoteDate = note.created_at;
      this.$bvModal.show("notes-modal");
    },
    formatDate(date) {
      return format(parseISO(date), "dd/MM/yyyy · HH:mm", { locale });
    }
  },
  watch: {
    patientId(newVal) {
      if (newVal) this.fetchAppointmentNotes();
    }
  }
};
</script>

<style scoped lang="scss">
.notes-history {
  width: 100%;

  &__empty {
    padding: var(--space-4) 0;
    font-size: var(--font-size-sm);
    color: var(--color-gray-400);
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3) var(--space-3);
    border-radius: var(--radius-md);
    transition: background 0.12s;

    &:hover {
      background: var(--color-gray-50);
    }
  }

  &__item-icon {
    width: 28px;
    height: 28px;
    border-radius: var(--radius-sm);
    background: var(--color-gray-100);
    color: var(--color-gray-400);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__item-date {
    flex: 1;
    font-size: var(--font-size-sm);
    color: var(--color-gray-700);
    line-height: 1.3;
  }

  &__item-btn {
    background: none;
    border: 1px solid var(--color-gray-300);
    border-radius: var(--radius-sm);
    color: var(--color-gray-600);
    font-size: var(--font-size-xs);
    font-weight: var(--fw-semibold);
    padding: 3px var(--space-3);
    cursor: pointer;
    transition: all 0.12s;
    white-space: nowrap;

    &:hover {
      background: var(--color-gray-100);
      color: var(--color-gray-900);
      border-color: var(--color-gray-400);
    }
  }

  &__modal-body {
    overflow: auto;
    min-height: 200px;
    max-height: 560px;
    font-size: var(--font-size-sm);
    line-height: 1.7;
  }
}
</style>
